import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {PromocionesListComponent} from './promociones-list.component';
import {PromocionesService} from './promociones.service';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {IIssuer} from '../ruteo/issuer';
import {RuteosService} from '../ruteo/ruteos.service';

@Component({
  selector: 'pm-add-promocion',
  templateUrl: './add-promocion.component.html',
  styleUrls: ['./add-promocion.component.sass']
})
export class AddPromocionComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'PROMOCIONES';

  issuerSelected = 0;
  issuerList: Observable<IIssuer[]> = this.routingService.getIssuers();

  constructor(public service: PromocionesService,
              private parent: PromocionesListComponent,
              private router: Router,
              private routingService: RuteosService) {
  }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
    }
    this.service.formData = {
      id: 0,
      interestFreeMonths: 0,
      minimumAmount: 0,
      status: '',
      cardIssuerId: '',
      cardIssuerName: ''
    };
  }

  ngAfterViewInit() {
    $('a[rel=promociones]').addClass('selected');
  }

  cancelPromocion(): void {
    this.parent.showPromociones = true;
    this.parent.showAddPromocion = false;
  }

  addPromocion(form: NgForm): void {
    console.log('addPromocion: form: ', form.value);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    form.value.status = parseInt(form.value.status);
    form.value.cardIssuerId = parseInt(form.value.cardIssuerId);

    const parentRef = this.parent;
    this.service.addPromocion(form.value).subscribe(
      res => {
        this.router.navigate(['/promociones']);
        parentRef.showPromociones = true;
        parentRef.showAddPromocion = false;
      },
      err => console.log('addPromocion: err: ', err)
    );
  }

  ngOnDestroy() {
    $('a[rel=promociones]').removeClass('selected');
  }
}
